module.exports = __webpack_public_path__ + "img/check.fcef01c0.svg";